<ng-select
  #ngSelect
  appendTo="body"
  class="user-selector"
  [ngClass]="classList"
  (change)="onChange($event)"
  (open)="onOpen($event)"
  (clear)="onClear($event)"
  [placeholder]="placeholder"
  [items]="items"
  [multiple]="multiple"
  [dropdownPosition]="dropdownPosition"
  [closeOnSelect]="closeOnSelect"
  [searchable]="true"
  [loading]="loading"
  [(ngModel)]="value"
  [minTermLength]="0"
  [disabled]="isDisabled"
  [compareWith]="compareFn"
  [typeahead]="quickSearchTermInput$"
  loadingText="{{ 'CA::Loading' | abpLocalization }}...">
  >
  <ng-template ng-label-tmp let-item="item">
    <div class="d-flex flex-row justify-content-start align-items-center">
      <i
        class="me-2 fa-solid fa-circle"
        [ngClass]="item.isActive ? 'circle-active' : 'circle-passive'"></i>
      <ca-user-photo
        *ngIf="userProfileThumbnailsCached"
        [useCurrentUser]="false"
        [userId]="item.id"
        [nameAndSurname]="[item.name, item.surname]"
        [styles]="userPhotoComponentStyles"></ca-user-photo>
      <span class="ms-2 ca-agent-identity">
        <span class="fullname truncate-text">{{ item.fullname }}</span>
        <span *ngIf="item.username" class="username">@{{ item.username }}</span>
      </span>
    </div>
  </ng-template>
  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    <div class="ng-value" *ngIf="items.length === 1">
      <span class="ng-value-label d-flex flex-row justify-content-start align-items-center">
        <i
          class="me-2 fa-solid fa-circle"
          [ngClass]="items[0].isActive ? 'circle-active' : 'circle-passive'"></i>
        <ca-user-photo
          *ngIf="userProfileThumbnailsCached"
          [useCurrentUser]="false"
          [userId]="items[0].id"
          [nameAndSurname]="[items[0].name, items[0].surname]"
          [styles]="userPhotoComponentStyles"></ca-user-photo>
        <span class="ms-2 ca-agent-identity">
          <span class="fullname truncate-text">{{ items[0].fullname }}</span>
          <span *ngIf="items[0].username" class="username">@{{ items[0].username }}</span>
        </span>
      </span>
    </div>
    <div class="ng-value" *ngIf="items.length > 1">
      <ng-container *ngIf="userType === 'all'">
        {{ 'AbpUi::UserPopupSelector:XUsersSelected' | abpLocalization: items.length }}...
      </ng-container>
      <ng-container *ngIf="userType === 'agent'">
        {{ 'AbpUi::UserPopupSelector:XAgentsSelected' | abpLocalization: items.length }}...
      </ng-container>
      <ng-container *ngIf="userType === 'evaluator'">
        {{ 'AbpUi::UserPopupSelector:XEvaluatorsSelected' | abpLocalization: items.length }}...
      </ng-container>
    </div>
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-item$="item$"
    let-index="index"
    let-search="searchTerm">
    <div class="d-flex flex-row justify-content-start align-items-center">
      <input *ngIf="multiple" type="checkbox" class="me-2" [ngModel]="item$.selected" />
      <i
        class="me-2 fa-solid fa-circle"
        [ngClass]="item.isActive ? 'circle-active' : 'circle-passive'"></i>
      <ca-user-photo
        *ngIf="userProfileThumbnailsCached"
        [useCurrentUser]="false"
        [userId]="item.id"
        [nameAndSurname]="[item.name, item.surname]"
        [styles]="userPhotoComponentStyles"></ca-user-photo>
      <span class="ms-2 ca-agent-identity">
        <span class="fullname truncate-text" [ngbTooltip]="item.fullname" container="body">{{
          item.fullname
        }}</span>
        <span *ngIf="item.username" class="username">@{{ item.username }}</span>
      </span>
    </div>
  </ng-template>
  <ng-template ng-header-tmp>
    <div
      class="d-flex flex-row align-items-center justify-content-start pt-1 pb-1"
      *ngIf="enabledUserStatusFilter">
      <div>
        <input
          id="rdAll"
          name="activityFilter"
          class="form-check-input"
          value="all"
          type="radio"
          (change)="onUserStatusFilterChanged($event)"
          [checked]="userStatusFilter === 'all'" />
        <label for="rdAll" class="form-check-label ms-2">
          <i class="fa-solid fa-circle-half circle-active"></i>
          <i class="fa-solid fa-circle-half fa-flip-horizontal circle-passive circle-stacked"></i>
          <span class="ms-2">{{ 'CA::All' | abpLocalization }}</span>
        </label>
      </div>
      <div class="ms-4">
        <input
          id="rdActive"
          name="activityFilter"
          class="form-check-input"
          value="active"
          type="radio"
          (change)="onUserStatusFilterChanged($event)"
          [checked]="userStatusFilter === 'active'" />
        <label for="rdActive" class="form-check-label ms-2">
          <i class="fa-solid fa-circle circle-active"></i>
          <span class="ms-2">{{ 'CA::Active' | abpLocalization }}</span>
        </label>
      </div>
      <div class="ms-4">
        <input
          id="rdPassive"
          name="activityFilter"
          class="form-check-input"
          value="passive"
          type="radio"
          (change)="onUserStatusFilterChanged($event)"
          [checked]="userStatusFilter === 'passive'" />
        <label for="rdPassive" class="form-check-label ms-2">
          <i class="fa-solid fa-circle circle-passive"></i>
          <span class="ms-2">{{ 'CA::Passive' | abpLocalization }}</span>
        </label>
      </div>
    </div>
  </ng-template>
  <ng-template ng-footer-tmp>
    <div class="w-100 d-flex d-flex flex-row justify-content-start align-items-center">
      <mat-paginator
        class="d-flex flex-row justify-content-row"
        style="flex: 0 0 350px"
        [length]="totalCount"
        [pageSize]="itemsPerPage"
        [pageIndex]="pageIndex"
        [hidePageSize]="true"
        [showFirstLastButtons]="true"
        (page)="onPageChange($event)"></mat-paginator>
    </div>
  </ng-template>
</ng-select>
